export const SingleValue = {
  value: '',
  options: { displayedValue: '' },
  constructor: function (value: string, options: any) {
    this.value = value;
    this.options = options;
  }
};
